import * as React from "react"

function IconPlus(props) {
    return (
        <svg
            width={32}
            height={32}
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path d="M24 16H8M16 24V8" stroke="#fff" strokeLinecap="round" />
        </svg>
    )
}

export default IconPlus
